import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import {
  chakraTheme,
  MainWindowProvider,
  polyfills,
  PopUpMessageProvider,
  ToastContainer,
  WebFetchDataProvider,
  WebFirebaseProvider,
} from '@hb/react-web'
// import 'focus-visible/dist/focus-visible'
import { AppProvider, PracticeAccessProvider } from '@hb/react'
import { AppErrorBoundary } from '@hb/react-web'
import { CookiesProvider } from 'react-cookie'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import { APP_NAME } from './constants'
// import {CookieBanner} from './1'

polyfills()

const emotionCache = createCache({
  key: 'emotion-css-cache',
  prepend: true, // ensures styles are prepended to the <head>, instead of appended
})

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <MainWindowProvider>
      <ColorModeScript type="cookie" initialColorMode="light" />
      <CacheProvider value={emotionCache}>
        <ChakraProvider
          theme={chakraTheme}
          portalZIndex={3}
          toastOptions={{ defaultOptions: { position: 'top' } }}>
          <Router>
            <AppErrorBoundary appName={APP_NAME}>
              <CookiesProvider>
                <PopUpMessageProvider>
                  <WebFirebaseProvider>
                    <WebFetchDataProvider>
                      <PracticeAccessProvider>
                        <AppProvider appName={APP_NAME}>
                          <App />
                        </AppProvider>
                      </PracticeAccessProvider>
                    </WebFetchDataProvider>
                  </WebFirebaseProvider>
                </PopUpMessageProvider>
              </CookiesProvider>
            </AppErrorBoundary>
          </Router>
        </ChakraProvider>
      </CacheProvider>
      <ToastContainer />
    </MainWindowProvider>,
  )
}
